import React from "react";
import "./Input.scss";
import InputProps from "./Input.types";

const Input = (props: InputProps) => {
  const {
    icon,
    fonts = "normal",
    placeholder,
    required,
    color,
    className,
    // background="#fff",
  } = props;
  const commonInputProp = {
    ...props,
    placeholder: required ? `${placeholder}` : placeholder,
    fonts,
    className: `input-${color} font--${fonts}${
      required ? " required" : ""
    } ${className} fw-500 fs-14`,
  };
  return (
    <div className="input-wrapper">
      <input
        {...commonInputProp}
        //need this for showing read only fields
        // style={{ background: `${props.background}` }}
      />
      {icon}
    </div>
  );
};

export default Input;
